import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { AuthShell, Field, inputCls, submitCls } from "@/components/AuthShell";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";

const linkCls = "font-semibold text-[#8B3A2B] underline-offset-4 hover:underline";

export default function ForgotPassword() {
  const { t, lang } = useLang();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email, lang });
      setSent(true);
    } catch (err) {
      setError(err?.response?.status === 422 ? t.auth.invalid : t.auth.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t.auth.forgotTitle} subtitle={t.auth.forgotSub}
      footer={<Link to="/login" className={linkCls} data-testid="forgot-back-to-login">{t.auth.backToLogin}</Link>}>
      {sent ? (
        <p className="flex gap-3 text-sm leading-relaxed text-emerald-900 bg-emerald-50 border border-emerald-200 p-4" data-testid="forgot-sent-msg">
          <MailCheck className="w-5 h-5 shrink-0" /> {t.auth.sentMsg}
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <Field label={t.auth.email}>
            <input type="email" required dir="ltr" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </Field>
          {error && <p className="text-sm text-red-800 bg-red-50 border border-red-200 p-3" data-testid="forgot-error">{error}</p>}
          <button disabled={loading} className={submitCls} data-testid="forgot-submit">{loading ? t.auth.sending : t.auth.sendLink}</button>
        </form>
      )}
    </AuthShell>
  );
}
